export default "__VITE_ASSET__CXqj_hX1__"